import DateRange from './date-range';
import {DateRangeType} from './types';

export default class PropertyFilterDateRange extends DateRange {
  public getDateRangeTypeOptions(): DateRangeType[] {
    return [
      DateRangeType.RelativeAfter,
      DateRangeType.RelativeBefore,
      DateRangeType.Between,
      DateRangeType.NotBetween,
      DateRangeType.On,
      DateRangeType.NotOn,
    ];
  }
}
